// Components
const SocialViewClubFeedsComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "social-view-club-feeds-component"*/ '@/app/views/main-view/social/components/social-view-club-feeds-component/social-view-club-feeds-component.vue');
const SocialViewAdminTabComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "social-view-admin-tab-component"*/ '@/app/views/main-view/social/components/social-view-club-admin-tab-component/social-view-club-admin-tab-component.vue');

// Constants
import { STATUS_CODES } from '@/app/constants/constants.js';

// Services
import PostService from '@/app/services/main/post/post-service.js';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

const defaultPaginateOption = {
    limit: 5,
    offset: 0
};

export default {
    name: 'SocialViewClubContainer',
    components: {
        SocialViewClubFeedsComponent,
        SocialViewAdminTabComponent
    },
    mixins: [ toastMessageMixins ],
    data() {
        return {
            tabs: [
                {
                    id: 'general',
                    label: 'Feeds',
                    active: true
                },
                {
                    id: 'admin',
                    label: 'Reports',
                    active: false
                }
            ],
            isAPILoading: false,
            feeds: [],
            options: { ...defaultPaginateOption },
            infiniteId: +new Date(),
            isAdminTab: false,
            reportContentId: 0,
            groupId: 0,
            clubName: 'Social Club'
        }
    },
    computed: {
        getActiveTab() {
            return this.tabs.find(tab => tab.active);
        }
    },
    created() {
        if (this.$route.params && this.$route.query) {
            this.groupId = this.$route.params.groupId;
            this.clubName = this.$route.query.club;
        }
    },
    methods: {
        backToGroup() {
			this.$router.push('/social');
		},
        refreshFeed() {
            this.feeds = [];
            this.options = { ...defaultPaginateOption };
            this.infiniteId += 1;
        },
        async infiniteHandler($state) {
            

            try {
                
                
                const {data:{posts}} = await PostService.getPosts({
                    topic: this.getActiveTab.id,
                    groupId: this.groupId,
                    offset: this.options.offset,
                    limit: this.options.limit
                });
                if (posts.length) {
                    this.feeds = this.feeds.concat(posts);
                    this.options.offset = this.options.offset + this.options.limit;

                    $state.loaded();
                    if (posts.length < this.options.limit) {
                        $state.complete();
                    }
                } else {
                    $state.complete();
                }
            } catch (error) {
                $state.error();
            }
        },
        async deletePostCallback(postId) {
            const res = await PostService.deletePost(postId);

            if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                this.feeds = this.feeds.filter(({ id }) => id !== postId);
                this.showCustomSuccessToast('Post has been deleted.');
            } else {
                const { ERROR_DELETE_POST } = this.toastMessages.post();
                this.showAPIErrorToast(ERROR_DELETE_POST, res);
            }
        },
        setActiveTab(selectedTab) {
            this.tabs = this.tabs.map(tab => {
                // set the selected tab to active
                tab.active = tab.id === selectedTab;
                // this is to show the admin component
                this.isAdminTab = selectedTab === 'admin';

                return tab;
            });

            this.refreshFeed();
        }
    }
}